import { resetPaymentAuthorisationAction } from "src/redux/app/actions";
import get from "src/lib/get";

export const GIFTS_RESET_STATE = "GIFTS_RESET_STATE";
export const GIFTS_ADD_PRODUCT = "GIFTS_ADD_PRODUCT";
export const GIFTS_REMOVE_PRODUCT = "GIFTS_REMOVE_PRODUCT";
export const GIFTS_EDIT_PRODUCT = "GIFTS_EDIT_PRODUCT";
export const GIFTS_SET_EXPRESS_DELIVERY = "GIFTS_SET_EXPRESS_DELIVERY";
export const GIFTS_SET_OFFER = "GIFTS_SET_OFFER";

export const resetGifts = (payload) => (dispatch) => {
  dispatch(resetPaymentAuthorisationAction());
  dispatch({ type: GIFTS_RESET_STATE, payload });
};

export const addProduct = (payload) => {
  return { type: GIFTS_ADD_PRODUCT, payload };
};

export const removeProduct = (payload = {}) => {
  const { productId } = payload;
  return {
    type: GIFTS_REMOVE_PRODUCT,
    payload: productId,
  };
};

export const editProduct = (payload) => {
  return { type: GIFTS_EDIT_PRODUCT, payload };
};

export const setExpressDelivery = (payload) => {
  return { type: GIFTS_SET_EXPRESS_DELIVERY, payload };
};

export const setOffer = (payload) => {
  return { type: GIFTS_SET_OFFER, payload };
};

export const addProductsFromQueryString = ({ giftProducts, query }) => (
  dispatch
) => {
  const skusFromQueryString = [].concat(get(query, "add", []));
  skusFromQueryString.forEach((sku) => {
    const product = giftProducts[sku.toString().toUpperCase()];
    if (product) {
      dispatch(
        addProduct({ productId: product.id, options: product.optionsDefaults })
      );
    }
  });
};
